import PaymentSystemInterface from 'app/interfaces/PaymentSystemInterface';
import React, {PureComponent} from 'react';
import {goToRoute} from 'app/utils/link_helper';
import SystemCard from 'app/components/deposit/SystemCard';
import {scrollToTop} from 'app/utils';

interface PropsInterface {
    active: boolean
    slug: string
    system: PaymentSystemInterface
    isSelectedSystem: boolean
}

export default class CashoutSystemTab extends PureComponent<PropsInterface> {
    selectSystem = (): void => {
        goToRoute(`/withdraws/${this.props.slug}`);
        scrollToTop();
    };

    render(): React.ReactNode {
        const {system, active, isSelectedSystem} = this.props;
        const disabledClassName = active ? '' : 'payment-systems__cashout__item__disabled';
        const selectedClassName = isSelectedSystem ? 'active' : '';
        return <div
            className={`payment-systems__cashout__item ${disabledClassName} ${selectedClassName}`}
            onClick={active && !isSelectedSystem ? this.selectSystem : null}
        >
            <SystemCard system={system}/>
        </div>;
    }
}
